import { createContext, useCallback, useContext, useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 480;

interface MobileContextValue {
    isMobile: boolean;
}

const MobileContext = createContext<MobileContextValue>({ isMobile: false });

export function MobileProvider({ children }: { children: React.ReactNode }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    const handleResize = useCallback(() => {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    }, []);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [handleResize]);

    return (
        <MobileContext.Provider value={{ isMobile }}>
            {children}
        </MobileContext.Provider>
    );
}

export function useMobile(): boolean {
    return useContext(MobileContext).isMobile;
}
